import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Snackbar,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";

import {
  getEncounterPrechartingDetails,
  updateEncounterPrechartNote,
} from "apiHandler/actions";
import { useUserData } from "components/customHooks/userDataContext";

import PreChartNote from "./preChartNote";
import { Close } from "@mui/icons-material";
import DocumentList from "./documentList";

const PreCharting = ({ open, onClose, row }) => {
  const userData = useUserData();

  const token = userData?.access_token;

  const [selectedNote, setSelectedNote] = useState("");

  const [selectedRow, setSelectedRow] = useState(null);

  const [loadingNote, setLoadingNote] = useState(true);
  const [userPrechartNote, setUserPrechartNote] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => setTabValue(newValue);

  useEffect(() => {
    if (open) {
      getPreCharting();
      setTabValue(0);
    }
    if (!open) setSelectedNote("");
  }, [open]);

  const getPreCharting = async () => {
    setLoadingNote(true);
    try {
      const res = await getEncounterPrechartingDetails(
        { encounter_id: row.encounter_id || row.id },
        token
      );

      if (res) {
        const data = res[0];
        setSelectedRow(data);
        setUserPrechartNote(
          data?.prechart_note.replace(/\n\n/g, "<br/>").replace(/\n/g, " ")
        );
        setSelectedNote(
          data?.prechart_note_ai.replace(/\n\n/g, "<br/>").replace(/\n/g, " ")
        );
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setLoadingNote(false);
    }
  };

  const onClosePreChart = () => {
    setSelectedRow(null);
    setSelectedRow(null);
    onClose();
  };

  const handleSaveNote = async () => {
    setLoadingNote(true);
    try {
      const payLoad = {
        precharting_id: row?.precharting_id,
        status: selectedRow?.status,
        prechart_note: userPrechartNote,
        missing_information: selectedRow?.missing_information,
        user_name: `${userData?.user_details?.first_name} ${userData?.user_details?.last_name}`,
      };
      const res = await updateEncounterPrechartNote(payLoad, token);

      if (res && res.status === "Success") {
        setSnackbarMsg("Note saved successfully.");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        getPreCharting();
      } else {
        setSnackbarMsg("Failed to save note.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.log("error: ", error);
      setSnackbarMsg("Error occurred while saving note.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoadingNote(false);
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  return (
    <Dialog open={open} maxWidth={false} fullWidth onClose={onClosePreChart}>
      <DialogContent>
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          mb={2}
        >
          <Typography variant="h6">Precharting</Typography>
          <IconButton onClick={onClosePreChart}>
            <Close />
          </IconButton>
        </Box>
        <Tabs value={tabValue} onChange={handleTabChange} sx={{ mb: 3 }}>
          <Tab label="Pre-Chart" />
          <Tab label="Documents" />
        </Tabs>
        {tabValue === 0 && (
          <PreChartNote
            handleSaveNote={handleSaveNote}
            noteDialogOpen={true}
            selectedNote={selectedNote}
            setUserPrechartNote={setUserPrechartNote}
            userPrechartNote={userPrechartNote}
            token={token}
            selectedRow={selectedRow}
            loading={loadingNote}
            setSelectedNote={setSelectedNote}
            data={selectedRow}
            row={row}
          />
        )}
        {tabValue === 1 && (
          <DocumentList
            token={token}
            selectedRow={selectedRow}
            row={row}
            userData={userData}
          />
        )}

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
            variant="filled"
          >
            {snackbarMsg}
          </Alert>
        </Snackbar>
      </DialogContent>
    </Dialog>
  );
};

export default PreCharting;
